import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {BannerCheckbox} from 'onboarding/ClientBanner';
import * as Colors from 'ui-library/Colors';

export default function DoDBanner(props: {
  showRequiredCheckbox: boolean;
  isChecked: boolean;
  setIsChecked: (checked: boolean) => void;
}): JSX.Element {
  return (
    <>
      <div className={css(styles.header)}>
        <strong>DoD Warning and Consent Banner</strong>
      </div>
      <p className={css(styles.warning)}>
        You are accessing a U. S. Government (USG) Information System (IS) that is provided for USG-authorized
        use only. By using this IS (which includes any device attached to this IS), you consent to the
        following conditions:
      </p>
      <div className={css(styles.bodyText)}>
        <ul>
          <li className={css(styles.listItem)}>
            The USG routinely intercepts and monitors communications on this IS for purposes including, but
            not limited to, penetration testing, COMSEC monitoring, network operations and defense, personnel
            misconduct (PM), law enforcement (LE), and counterintelligence (CI) investigations.
          </li>
          <li className={css(styles.listItem)}>
            At any time, the USG may inspect and seize data stored on this IS.
          </li>
          <li className={css(styles.listItem)}>
            Communications using, or data stored on, this IS are not private, are subject to routine
            monitoring, interception, and search, and may be disclosed or used for any USG authorized purpose.
          </li>
          <li className={css(styles.listItem)}>
            This IS includes security measures (e.g., authentication and access controls) to protect USG
            interests--not for your personal benefit or privacy.
          </li>
          <li className={css(styles.listItem)}>
            Notwithstanding the above, using this IS does not constitute consent to PM, LE or CI investigative
            searching or monitoring of the content of privileged communications, or work product, related to
            personal representation or services by attorneys, psychotherapists, or clergy, and their
            assistants. Such communications and work product are private and confidential. See User Agreement
            for details.
          </li>
        </ul>
      </div>
      <div className={css(styles.bodyText)}>
        <p>Welcome to Benchling Informatics for Biological R&amp;D (BIBRD) (Benchlinggov.com)</p>
        <p>
          <strong>
            BIBRD is not approved for classified work. STORAGE OF ANY CLASSIFIED INFORMATION IS PROHIBITED.
          </strong>
        </p>
        <p>
          BIBRD is implemented to facilitate designing and sharing of genetic constructs and for storing
          experimental data. Users are required to access this service through a Common Access Card
          (CAC)-restricted computer. By-passing the restriction is a violation of the BIBRD User Agreement.
          This service is funded through the OSD Applied Research for the Advancement of S&amp;T Priority -
          Synthetic Biology for Military Environment program.
        </p>
        <p>
          We seek to build a Biotechnology Research Community within DoD. Please join the vision to develop a
          collaborative and sharing community. Enjoy BIBRD. If you have any problems accessing or any
          questions regarding this service, please contact your site-specific admin.
        </p>
        {props.showRequiredCheckbox && (
          <BannerCheckbox
            isChecked={props.isChecked}
            setIsChecked={props.setIsChecked}
            labelText="I agree with the DoD Warning and Consent Banner as stated above"
          />
        )}
      </div>
    </>
  );
}

const styles = StyleSheet.create({
  header: {
    fontSize: 24,
  },
  warning: {
    fontSize: 15,
    color: Colors.RED_DARK,
    fontWeight: 'bold',
  },
  bodyText: {
    fontSize: 15,
  },
  listItem: {
    marginBottom: 5,
  },
});
